export const COMMUNITY_REPORT_FORMATTER_I18N = Object.freeze({
  EN: Object.freeze({
    header_data_maps: "Data Maps",
    header_more: "More options",
    header_language_theme: "Language & theme",
    settings_title: "Language & Theme",
    settings_close: "Close settings",
    settings_select_language: "Select Language",
    settings_appearance: "Appearance",
    settings_language_english: "English",
    settings_language_spanish: "Spanish",
    settings_theme_light: "Light",
    settings_theme_dark: "Dark",
    data_directory_document_title: "Data Maps | iDetect",
    data_directory_home: "Home",
    data_directory_maps_aria: "Available maps",
    data_directory_title: "Data Maps",
    data_directory_intro: "Explore available iDetect maps.",
    data_hex_title: "Hex Map",
    data_hex_description: "Explore community report patterns using adjustable hexagonal map regions.",
    data_county_title: "County Map",
    data_county_description: "Explore community report patterns across Arizona counties.",
    data_open_map: "Open map",
    county_document_title: "County Map | iDetect",
    county_page_aria: "Arizona county sample-data map",
    county_data: "Data Maps",
    county_eyebrow: "Experimental map",
    county_title: "Arizona County Map",
    county_intro: "The deterministic values are not live reports. Adjust the cutoffs to change only the shading; the sample counts do not change.",
    county_sample_badge: "Sample data",
    county_sample_explanation: "This map currently uses sample data for demonstration purposes.",
    county_sample_popup_note: "Sample data",
    county_demo_period: "Demonstration dataset",
    county_controls_aria: "County map shading controls",
    county_thresholds_aria: "County sick-report count shading thresholds",
    county_thresholds: "Sick-report count shading",
    county_threshold_instruction: "Drag each dot to set a color cutoff.",
    county_yellow_orange: "Yellow → orange: {count}",
    county_orange_red: "Orange → red: {count}",
    county_yellow_orange_aria: "Yellow to orange county sick-report count cutoff",
    county_orange_red_aria: "Orange to red county sick-report count cutoff",
    county_legend_aria: "County sick-report count legend",
    county_legend_no_data: "Gray: No county data returned",
    county_legend_low: "Light yellow: fewer than {count}",
    county_legend_middle: "Orange: {lower} to below {upper}",
    county_legend_high: "Red: {count} or more",
    county_map_aria: "Arizona county map shaded by sample sick-report counts",
    county_map_description: "The map shows all Arizona counties using deterministic sample data. Yellow, orange, and red shading represents sample sick-report counts using the adjustable cutoffs. Select a county to view its exact sample counts.",
    county_loading: "Loading county map data…",
    county_loaded: "Sample county map loaded.",
    county_geometry_unavailable: "County map data is unavailable.",
    county_map_unavailable: "Map unavailable",
    county_mapbox_token: "A Mapbox token is required to display the county map.",
    county_mapbox_help: "Open this page with ?mapboxToken=YOUR_TOKEN to display Arizona.",
    county_select_note: "Hover to preview a county, or click or tap it to keep its details open.",
    county_no_data: "No county data returned",
    county_sick_report_one: "{count} sick report",
    county_sick_report_many: "{count} sick reports",
    county_total_report_one: "{count} total report",
    county_total_report_many: "{count} total reports",
    hex_page_aria: "Arizona hex-bin mock report map",
    hex_preview: "Mock data preview",
    hex_title: "Arizona report quantity",
    hex_data: "Data",
    hex_intro: "A proof of concept using deterministic mock human reports. Hex colors show sick-report counts, while center-dot sizes show total report quantity in the active time window; zoom in to see smaller H3 cells.",
    hex_controls_aria: "Map controls",
    hex_symptom_selector: "Symptom selector",
    hex_symptoms: "Symptoms",
    hex_symptom_instruction: "Show reports that include every selected symptom.",
    hex_required_symptoms: "Required symptoms",
    hex_clear_symptoms: "Clear symptom filters",
    hex_map_layers: "Map layers",
    hex_human: "Human",
    hex_sick_shading: "Sick-report shading",
    hex_report_dots: "Report-count dots",
    hex_additional_reports: "Additional reports",
    hex_animal_reports: "Animal reports",
    hex_environment_reports: "Environment reports",
    hex_map_aria: "Arizona report quantity map",
    hex_legend_aria: "Hex map legend",
    hex_larger_dots: "Larger red dots: more reports",
    hex_resolution: "H3 resolution {resolution}",
    hex_popup_resolution: "H3 resolution: {resolution}",
    hex_click_note: "Click a hexagon for its mock report counts.",
    hex_map_unavailable: "Map unavailable",
    hex_time_window: "Time window",
    hex_time_behavior: "Reports accumulate from the active start date through the selected end date.",
    hex_pause_playback: "Pause time playback",
    hex_play_playback: "Play time playback",
    hex_pause: "Pause",
    hex_play: "Play",
    hex_active_start: "Active start",
    hex_selected_end: "Selected end",
    hex_start_date_aria: "Hex map start date",
    hex_selected_end_date_aria: "Hex map selected end date",
    hex_empty_one_symptom: "No human reports contain {symptom} in this date range",
    hex_empty_many_symptoms: "No human reports contain all selected symptoms in this date range",
    hex_empty: "No mock reports in this cumulative date range",
    hex_thresholds_aria: "Sick-report count shading thresholds",
    hex_thresholds: "Sick-report count shading",
    hex_threshold_instruction: "Drag each dot to set a color cutoff.",
    hex_yellow_orange: "Yellow → orange: {count}",
    hex_orange_red: "Orange → red: {count}",
    hex_yellow_orange_aria: "Yellow to orange sick-report count cutoff",
    hex_orange_red_aria: "Orange to red sick-report count cutoff",
    hex_legend_low: "Light yellow: fewer than {count}",
    hex_legend_middle: "Orange: {lower} to below {upper}",
    hex_legend_high: "Red: {count} or more",
    hex_sick_report_one: "{count} sick report",
    hex_sick_report_many: "{count} sick reports",
    hex_symptomatic_report_one: "{count} symptomatic report",
    hex_symptomatic_report_many: "{count} symptomatic reports",
    hex_human_report_one: "{count} human report",
    hex_human_report_many: "{count} human reports",
    hex_report_one: "{count} report",
    hex_report_many: "{count} reports",
    hex_no_symptom_filter: "No symptom filter",
    hex_containing: "{reports} containing {symptom}",
    hex_containing_all: "{reports} containing all selected symptoms",
    hex_time_summary: "{window} · {reports}",
    hex_time_from: "From {range}",
    hex_time_through: "through",
    hex_all_dates: "All available dates",
    hex_popup_cell: "Mock report cell",
    hex_popup_total: "Total reports: {count}",
    hex_popup_time: "Time: {time}",
    hex_popup_symptoms_all: "Symptoms: All",
    hex_popup_symptom: "Required symptom: {symptom}",
    hex_popup_symptoms: "Required symptoms: {symptoms}",
    hex_popup_filtered: "Filtered by {count} required symptoms",
    hex_popup_subtype: "Subtype: {value}",
    hex_popup_severity: "Severity: {value}",
    hex_popup_date: "Report date: {date}",
    hex_not_specified: "Not specified",
    hex_symptom_cough_congestion: "Cough/congestion",
    hex_mapbox_token: "Mapbox token needed",
    hex_mapbox_help: "Open this page with ?mapboxToken=YOUR_TOKEN to render Arizona.",
    hex_loading: "Loading map...",
    map_report_one: "{count} report",
    map_report_many: "{count} reports",
    map_report: "Report",
    map_animal_report: "Animal report",
    map_environment_report: "Environment report",
    map_subtype_dead_bird: "Dead bird",
    map_subtype_mass_die_off: "Mass die-off",
    map_subtype_sick_livestock: "Sick livestock",
    map_subtype_unusual_behavior: "Unusual behavior",
    map_subtype_wildlife_carcass: "Wildlife carcass",
    map_subtype_air_quality: "Air quality",
    map_subtype_algal_bloom: "Algal bloom",
    map_subtype_chemical_odor: "Chemical odor",
    map_subtype_fish_kill: "Fish kill",
    map_subtype_water_discoloration: "Water discoloration",
    map_severity_low: "Low",
    map_severity_medium: "Medium",
    map_severity_high: "High",
    map_zip: "ZIP",
    map_sick: "with symptoms",
    map_healthy_lower: "healthy",
    map_people_reported_sick_one: "{count} person reported symptoms",
    map_people_reported_sick_many: "{count} people reported symptoms",
    map_latest_report: "Latest report: {date}",
    map_severity: "{severity} severity",
    map_resident_one: "~{count} resident",
    map_resident_many: "~{count} residents",
    map_population_unavailable: "population n/a",
    map_sick_share: "{percent}% reported symptoms",
    map_per_thousand: "{count} per 1k",
    map_insufficient_population: "Insufficient data (small population)",
    map_no_people_reports: "No people reports yet",
    map_animal_count_one: "🐾 {count} animal",
    map_animal_count_many: "🐾 {count} animals",
    map_environment_count_one: "🌫️ {count} environmental report",
    map_environment_count_many: "🌫️ {count} environmental reports",
    map_high_severity_count_one: "{count} high-severity report",
    map_high_severity_count_many: "{count} high-severity reports",
    pulse_recent_reports: "Recent reports",
    pulse_title: "Community Pulse",
    pulse_area_aria: "Recent report area",
    pulse_all_recent: "All recent",
    pulse_in_your_area: "In your area",
    pulse_your_report: "Your report",
    pulse_set_county: "Submit a report to set your county for this browser.",
    pulse_loading: "Loading recent community activity...",
    pulse_refreshing: "Refreshing recent activity...",
    pulse_unavailable: "Recent activity is unavailable right now.",
    pulse_stale: "Could not refresh; showing the last available activity.",
    pulse_empty_county: "No recent reports in {county}.",
    pulse_empty_all: "No community reports were received in the last seven days.",
    pulse_healthy_human: "Healthy human report",
    pulse_sick_human: "Sick human report",
    pulse_environmental_concern: "Environmental concern",
    pulse_mixed_report: "Mixed community report",
    pulse_community_report: "Community report",
    pulse_animal_concern: "{animal} concern",
    pulse_row_in: "{concern} in {location}",
    pulse_row_reported_in: "{concern} reported in {location}",
    pulse_environment_reported_in: "Environmental concern reported in {location}",
    pulse_multiple_reported_in: "Multiple concerns reported in {location}",
    pulse_community_concern_in: "Community concern reported in {location}",
    pulse_people_animals: "{people} and {animal}",
    pulse_people_environment: "{people} and environmental concern",
    pulse_animals_environment: "{animal} and environmental concerns reported",
    pulse_multiple_reported: "Multiple concerns reported",
    pulse_animal: "animal",
    pulse_pet: "pet",
    pulse_livestock: "livestock",
    pulse_wildlife: "wildlife",
    pulse_county_name: "{county} County",
    pulse_time_just_now: "just now",
    pulse_time_recently: "recently",
    pulse_time_yesterday: "yesterday",
    pulse_time_minute_ago: "{count} min ago",
    pulse_time_minutes_ago: "{count} min ago",
    pulse_time_hour_ago: "{count} hour ago",
    pulse_time_hours_ago: "{count} hours ago",
    pulse_time_day_ago: "{count} day ago",
    pulse_time_days_ago: "{count} days ago",
    pulse_no_symptoms: "No symptoms reported",
    pulse_severity: "Severity: {value}",
    pulse_symptoms: "Symptoms: {value}",
    pulse_human_health_report: "Human health report",
    pulse_group: "Group: {value}",
    pulse_type: "Type: {value}",
    pulse_sick_animals: "Sick animals: {value}",
    pulse_dead_animals: "Dead animals: {value}",
    pulse_animal_health_report: "Animal health report",
    pulse_concern: "Concern: {value}",
    pulse_environmental_report: "Environmental report",
    pulse_county: "County: {value}",
    pulse_reported: "Reported {time}",
    pulse_more: "+{count} more",
    pulse_severity_mild: "Mild",
    pulse_severity_moderate: "Moderate",
    pulse_severity_severe: "Severe",
    pulse_animal_type_bird: "Bird",
    pulse_animal_type_mammal: "Mammal",
    pulse_animal_type_reptile: "Reptile",
    pulse_animal_type_fish: "Fish",
    pulse_animal_type_amphibian: "Amphibian",
    pulse_animal_type_other: "Other",
    pulse_environment_vector_activity: "vector activity",
    pulse_environment_water_contamination: "water contamination",
    pulse_environment_raw_sewage: "raw sewage",
    pulse_environment_air_quality: "air quality",
    pulse_environment_flooding: "flooding",
    pulse_environment_plant_or_crop_damage: "plant or crop damage",
    pulse_environment_other: "other",
    pulse_symptom_cough: "cough",
    pulse_symptom_congestion: "congestion",
    pulse_symptom_nausea: "nausea",
    pulse_symptom_difficulty_breathing: "difficulty breathing",
    pulse_symptom_sore_throat: "sore throat",
    pulse_symptom_rash: "rash",
    pulse_symptom_fever: "fever",
    pulse_symptom_chills: "chills",
    pulse_symptom_diarrhea: "diarrhea",
    pulse_symptom_bleeding: "bleeding",
    pulse_symptom_red_eyes: "red eyes",
    pulse_symptom_body_aches: "body aches",
    pulse_symptom_headache: "headache",
    pulse_symptom_discolored_or_bloody_urine: "discolored or bloody urine",
    pulse_symptom_loss_of_smell_or_taste: "loss of smell or taste",
    pulse_symptom_yellow_skin_or_eyes: "yellow skin or eyes",
    pulse_symptom_animal_bite: "animal bite",
    pulse_symptom_bug_bite: "bug bite",
    pulse_symptom_other: "other",
  }),
  ES: Object.freeze({
    header_data_maps: "Mapas de datos",
    header_more: "Más opciones",
    header_language_theme: "Idioma y tema",
    settings_title: "Idioma y tema",
    settings_close: "Cerrar configuración",
    settings_select_language: "Seleccionar idioma",
    settings_appearance: "Apariencia",
    settings_language_english: "Inglés",
    settings_language_spanish: "Español",
    settings_theme_light: "Claro",
    settings_theme_dark: "Oscuro",
    data_directory_document_title: "Mapas de datos | iDetect",
    data_directory_home: "Inicio",
    data_directory_maps_aria: "Mapas disponibles",
    data_directory_title: "Mapas de datos",
    data_directory_intro: "Explora los mapas disponibles de iDetect.",
    data_hex_title: "Mapa hex",
    data_hex_description: "Explora los patrones de reportes comunitarios mediante regiones hexagonales ajustables.",
    data_county_title: "Mapa por condado",
    data_county_description: "Explora los patrones de reportes comunitarios en los condados de Arizona.",
    data_open_map: "Abrir mapa",
    county_document_title: "Mapa por condado | iDetect",
    county_page_aria: "Mapa de Arizona por condado con datos de muestra",
    county_data: "Mapas de datos",
    county_eyebrow: "Mapa experimental",
    county_title: "Mapa de condados de Arizona",
    county_intro: "Los valores deterministas no son reportes en vivo. Ajusta los límites para cambiar solo el sombreado; las cantidades de muestra no cambian.",
    county_sample_badge: "Datos de muestra",
    county_sample_explanation: "Este mapa utiliza actualmente datos de muestra con fines de demostración.",
    county_sample_popup_note: "Datos de muestra",
    county_demo_period: "Conjunto de datos de demostración",
    county_controls_aria: "Controles de sombreado del mapa por condado",
    county_thresholds_aria: "Umbrales de sombreado según cantidad de reportes de enfermedad por condado",
    county_thresholds: "Sombreado según cantidad de reportes de enfermedad",
    county_threshold_instruction: "Arrastra cada punto para establecer un límite de color.",
    county_yellow_orange: "Amarillo → naranja: {count}",
    county_orange_red: "Naranja → rojo: {count}",
    county_yellow_orange_aria: "Límite de amarillo a naranja para reportes de enfermedad por condado",
    county_orange_red_aria: "Límite de naranja a rojo para reportes de enfermedad por condado",
    county_legend_aria: "Leyenda de reportes de enfermedad por condado",
    county_legend_no_data: "Gris: No se devolvieron datos del condado",
    county_legend_low: "Amarillo claro: menos de {count}",
    county_legend_middle: "Naranja: de {lower} a menos de {upper}",
    county_legend_high: "Rojo: {count} o más",
    county_map_aria: "Mapa de Arizona sombreado según cantidades de muestra de reportes de enfermedad por condado",
    county_map_description: "El mapa muestra todos los condados de Arizona con datos de muestra deterministas. El sombreado amarillo, naranja y rojo representa las cantidades de muestra de reportes de enfermedad según los límites ajustables. Selecciona un condado para ver sus cantidades de muestra exactas.",
    county_loading: "Cargando los datos del mapa por condado…",
    county_loaded: "Se cargó el mapa por condado con datos de muestra.",
    county_geometry_unavailable: "Los datos del mapa por condado no están disponibles.",
    county_map_unavailable: "Mapa no disponible",
    county_mapbox_token: "Se necesita un token de Mapbox para mostrar el mapa por condado.",
    county_mapbox_help: "Abre esta página con ?mapboxToken=YOUR_TOKEN para mostrar Arizona.",
    county_select_note: "Pasa el puntero para obtener una vista previa, o haz clic o toca un condado para mantener abiertos sus detalles.",
    county_no_data: "No se devolvieron datos del condado",
    county_sick_report_one: "{count} reporte de enfermedad",
    county_sick_report_many: "{count} reportes de enfermedad",
    county_total_report_one: "{count} reporte total",
    county_total_report_many: "{count} reportes totales",
    hex_page_aria: "Mapa simulado de reportes en hexágonos de Arizona",
    hex_preview: "Vista previa con datos simulados",
    hex_title: "Cantidad de reportes de Arizona",
    hex_data: "Datos",
    hex_intro: "Una prueba de concepto que usa reportes humanos simulados y deterministas. Los colores de los hexágonos muestran la cantidad de reportes de enfermedad, mientras que el tamaño de los puntos centrales muestra el total de reportes en la ventana de tiempo activa; acerca el mapa para ver celdas H3 más pequeñas.",
    hex_controls_aria: "Controles del mapa",
    hex_symptom_selector: "Selector de síntomas",
    hex_symptoms: "Síntomas",
    hex_symptom_instruction: "Muestra los reportes que incluyen cada síntoma seleccionado.",
    hex_required_symptoms: "Síntomas obligatorios",
    hex_clear_symptoms: "Borrar filtros de síntomas",
    hex_map_layers: "Capas del mapa",
    hex_human: "Personas",
    hex_sick_shading: "Sombreado de reportes de enfermedad",
    hex_report_dots: "Puntos de cantidad de reportes",
    hex_additional_reports: "Reportes adicionales",
    hex_animal_reports: "Reportes de animales",
    hex_environment_reports: "Reportes ambientales",
    hex_map_aria: "Mapa de cantidad de reportes de Arizona",
    hex_legend_aria: "Leyenda del mapa de hexágonos",
    hex_larger_dots: "Puntos rojos más grandes: más reportes",
    hex_resolution: "Resolución H3 {resolution}",
    hex_popup_resolution: "Resolución H3: {resolution}",
    hex_click_note: "Selecciona un hexágono para ver sus cantidades de reportes simulados.",
    hex_map_unavailable: "Mapa no disponible",
    hex_time_window: "Ventana de tiempo",
    hex_time_behavior: "Los reportes se acumulan desde la fecha inicial activa hasta la fecha final seleccionada.",
    hex_pause_playback: "Pausar la reproducción temporal",
    hex_play_playback: "Reproducir la línea de tiempo",
    hex_pause: "Pausar",
    hex_play: "Reproducir",
    hex_active_start: "Inicio activo",
    hex_selected_end: "Fin seleccionado",
    hex_start_date_aria: "Fecha inicial del mapa de hexágonos",
    hex_selected_end_date_aria: "Fecha final seleccionada del mapa de hexágonos",
    hex_empty_one_symptom: "Ningún reporte de personas contiene {symptom} en este intervalo de fechas",
    hex_empty_many_symptoms: "Ningún reporte de personas contiene todos los síntomas seleccionados en este intervalo de fechas",
    hex_empty: "No hay reportes simulados en este intervalo acumulado de fechas",
    hex_thresholds_aria: "Umbrales de sombreado según cantidad de reportes de enfermedad",
    hex_thresholds: "Sombreado según cantidad de reportes de enfermedad",
    hex_threshold_instruction: "Arrastra cada punto para establecer un límite de color.",
    hex_yellow_orange: "Amarillo → naranja: {count}",
    hex_orange_red: "Naranja → rojo: {count}",
    hex_yellow_orange_aria: "Límite de cantidad de reportes de enfermedad de amarillo a naranja",
    hex_orange_red_aria: "Límite de cantidad de reportes de enfermedad de naranja a rojo",
    hex_legend_low: "Amarillo claro: menos de {count}",
    hex_legend_middle: "Naranja: de {lower} a menos de {upper}",
    hex_legend_high: "Rojo: {count} o más",
    hex_sick_report_one: "{count} reporte de enfermedad",
    hex_sick_report_many: "{count} reportes de enfermedad",
    hex_symptomatic_report_one: "{count} reporte sintomático",
    hex_symptomatic_report_many: "{count} reportes sintomáticos",
    hex_human_report_one: "{count} reporte de personas",
    hex_human_report_many: "{count} reportes de personas",
    hex_report_one: "{count} reporte",
    hex_report_many: "{count} reportes",
    hex_no_symptom_filter: "Sin filtro de síntomas",
    hex_containing: "{reports} que contienen {symptom}",
    hex_containing_all: "{reports} que contienen todos los síntomas seleccionados",
    hex_time_summary: "{window} · {reports}",
    hex_time_from: "Desde {range}",
    hex_time_through: "hasta",
    hex_all_dates: "Todas las fechas disponibles",
    hex_popup_cell: "Celda de reportes simulados",
    hex_popup_total: "Reportes totales: {count}",
    hex_popup_time: "Tiempo: {time}",
    hex_popup_symptoms_all: "Síntomas: todos",
    hex_popup_symptom: "Síntoma obligatorio: {symptom}",
    hex_popup_symptoms: "Síntomas obligatorios: {symptoms}",
    hex_popup_filtered: "Filtrado por {count} síntomas obligatorios",
    hex_popup_subtype: "Subtipo: {value}",
    hex_popup_severity: "Gravedad: {value}",
    hex_popup_date: "Fecha del reporte: {date}",
    hex_not_specified: "No especificado",
    hex_symptom_cough_congestion: "Tos/congestión",
    hex_mapbox_token: "Se necesita un token de Mapbox",
    hex_mapbox_help: "Abre esta página con ?mapboxToken=YOUR_TOKEN para mostrar Arizona.",
    hex_loading: "Cargando mapa...",
    map_report_one: "{count} reporte",
    map_report_many: "{count} reportes",
    map_report: "Reporte",
    map_animal_report: "Reporte de animales",
    map_environment_report: "Reporte del medio ambiente",
    map_subtype_dead_bird: "Ave muerta",
    map_subtype_mass_die_off: "Mortandad masiva",
    map_subtype_sick_livestock: "Ganado enfermo",
    map_subtype_unusual_behavior: "Comportamiento inusual",
    map_subtype_wildlife_carcass: "Cadáver de animal silvestre",
    map_subtype_air_quality: "Calidad del aire",
    map_subtype_algal_bloom: "Floración de algas",
    map_subtype_chemical_odor: "Olor químico",
    map_subtype_fish_kill: "Mortandad de peces",
    map_subtype_water_discoloration: "Cambio de color del agua",
    map_severity_low: "Baja",
    map_severity_medium: "Media",
    map_severity_high: "Alta",
    map_zip: "Código postal",
    map_sick: "con síntomas",
    map_healthy_lower: "saludables",
    map_people_reported_sick_one: "{count} persona reportó síntomas",
    map_people_reported_sick_many: "{count} personas reportaron síntomas",
    map_latest_report: "Reporte más reciente: {date}",
    map_severity: "Gravedad: {severity}",
    map_resident_one: "~{count} residente",
    map_resident_many: "~{count} residentes",
    map_population_unavailable: "población no disponible",
    map_sick_share: "{percent}% reportó síntomas",
    map_per_thousand: "{count} por cada mil",
    map_insufficient_population: "Datos insuficientes (población pequeña)",
    map_no_people_reports: "Aún no hay reportes de personas",
    map_animal_count_one: "🐾 {count} animal",
    map_animal_count_many: "🐾 {count} animales",
    map_environment_count_one: "🌫️ {count} reporte ambiental",
    map_environment_count_many: "🌫️ {count} reportes ambientales",
    map_high_severity_count_one: "{count} reporte de gravedad alta",
    map_high_severity_count_many: "{count} reportes de gravedad alta",
    pulse_recent_reports: "Reportes recientes",
    pulse_title: "Pulso de la comunidad",
    pulse_area_aria: "Área de reportes recientes",
    pulse_all_recent: "Todos los recientes",
    pulse_in_your_area: "En tu área",
    pulse_your_report: "Tu reporte",
    pulse_set_county: "Envía un reporte para establecer tu condado en este navegador.",
    pulse_loading: "Cargando actividad reciente de la comunidad...",
    pulse_refreshing: "Actualizando la actividad reciente...",
    pulse_unavailable: "La actividad reciente no está disponible en este momento.",
    pulse_stale: "No se pudo actualizar; se muestra la última actividad disponible.",
    pulse_empty_county: "No hay reportes recientes en {county}.",
    pulse_empty_all: "No se recibieron reportes de la comunidad en los últimos siete días.",
    pulse_healthy_human: "Reporte sobre una persona saludable",
    pulse_sick_human: "Reporte sobre una persona enferma",
    pulse_environmental_concern: "Preocupación ambiental",
    pulse_mixed_report: "Reporte comunitario mixto",
    pulse_community_report: "Reporte comunitario",
    pulse_animal_concern: "preocupación sobre {animal}",
    pulse_row_in: "{concern} en {location}",
    pulse_row_reported_in: "{concern} reportada en {location}",
    pulse_environment_reported_in: "Preocupación ambiental reportada en {location}",
    pulse_multiple_reported_in: "Varias preocupaciones reportadas en {location}",
    pulse_community_concern_in: "Preocupación comunitaria reportada en {location}",
    pulse_people_animals: "{people} y {animal}",
    pulse_people_environment: "{people} y una preocupación ambiental",
    pulse_animals_environment: "{animal} y preocupaciones ambientales reportadas",
    pulse_multiple_reported: "Varias preocupaciones reportadas",
    pulse_animal: "animales",
    pulse_pet: "mascotas",
    pulse_livestock: "ganado",
    pulse_wildlife: "vida silvestre",
    pulse_county_name: "condado de {county}",
    pulse_time_just_now: "ahora mismo",
    pulse_time_recently: "recientemente",
    pulse_time_yesterday: "ayer",
    pulse_time_minute_ago: "hace {count} minuto",
    pulse_time_minutes_ago: "hace {count} minutos",
    pulse_time_hour_ago: "hace {count} hora",
    pulse_time_hours_ago: "hace {count} horas",
    pulse_time_day_ago: "hace {count} día",
    pulse_time_days_ago: "hace {count} días",
    pulse_no_symptoms: "No se reportaron síntomas",
    pulse_severity: "Gravedad: {value}",
    pulse_symptoms: "Síntomas: {value}",
    pulse_human_health_report: "Reporte de salud humana",
    pulse_group: "Grupo: {value}",
    pulse_type: "Tipo: {value}",
    pulse_sick_animals: "Animales enfermos: {value}",
    pulse_dead_animals: "Animales muertos: {value}",
    pulse_animal_health_report: "Reporte de salud animal",
    pulse_concern: "Preocupación: {value}",
    pulse_environmental_report: "Reporte ambiental",
    pulse_county: "Ubicación: {value}",
    pulse_reported: "Reportado {time}",
    pulse_more: "+{count} más",
    pulse_severity_mild: "Leve",
    pulse_severity_moderate: "Moderada",
    pulse_severity_severe: "Grave",
    pulse_animal_type_bird: "Ave",
    pulse_animal_type_mammal: "Mamífero",
    pulse_animal_type_reptile: "Reptil",
    pulse_animal_type_fish: "Pez",
    pulse_animal_type_amphibian: "Anfibio",
    pulse_animal_type_other: "Otro",
    pulse_environment_vector_activity: "actividad de vectores",
    pulse_environment_water_contamination: "contaminación del agua",
    pulse_environment_raw_sewage: "aguas residuales sin tratar",
    pulse_environment_air_quality: "calidad del aire",
    pulse_environment_flooding: "inundación",
    pulse_environment_plant_or_crop_damage: "daño a plantas o cultivos",
    pulse_environment_other: "otra",
    pulse_symptom_cough: "tos",
    pulse_symptom_congestion: "congestión",
    pulse_symptom_nausea: "náuseas",
    pulse_symptom_difficulty_breathing: "dificultad para respirar",
    pulse_symptom_sore_throat: "dolor de garganta",
    pulse_symptom_rash: "erupción cutánea",
    pulse_symptom_fever: "fiebre",
    pulse_symptom_chills: "escalofríos",
    pulse_symptom_diarrhea: "diarrea",
    pulse_symptom_bleeding: "sangrado",
    pulse_symptom_red_eyes: "ojos rojos",
    pulse_symptom_body_aches: "dolores corporales",
    pulse_symptom_headache: "dolor de cabeza",
    pulse_symptom_discolored_or_bloody_urine: "orina descolorida o con sangre",
    pulse_symptom_loss_of_smell_or_taste: "pérdida del olfato o del gusto",
    pulse_symptom_yellow_skin_or_eyes: "piel u ojos amarillos",
    pulse_symptom_animal_bite: "mordedura de animal",
    pulse_symptom_bug_bite: "picadura de insecto",
    pulse_symptom_other: "otro",
  }),
});

export function interpolateCommunityReportCopy(template, replacements = {}) {
  return String(template || "").replace(/\{([a-zA-Z0-9_]+)\}/g, (match, name) => (
    Object.hasOwn(replacements, name) ? String(replacements[name]) : match
  ));
}

export function communityReportCopy(language, key) {
  const selected = language === "ES" ? COMMUNITY_REPORT_FORMATTER_I18N.ES : COMMUNITY_REPORT_FORMATTER_I18N.EN;
  return selected[key] || COMMUNITY_REPORT_FORMATTER_I18N.EN[key] || "";
}

export function formatCommunityReportCopy(language, key, replacements = {}) {
  return interpolateCommunityReportCopy(communityReportCopy(language, key), replacements);
}

export function countCommunityReportCopy(
  language,
  oneKey,
  manyKey,
  count,
  replacements = {}
) {
  return formatCommunityReportCopy(
    language,
    count === 1 ? oneKey : manyKey,
    { count, ...replacements }
  );
}
